import moment from "moment-timezone";
import { LocalStorageConstants, LocalStorageValueConstants } from "../constants/ApplicationConstants/LocalStorageConstants";
import LocalStorageUtil from "./LocalStorageUtil";
import { ModuleOperation, UserInterface } from "../shared/interface/auth/User.interface";
import { ModuleAndIdMapping, Modules } from "../constants/DatabaseConstants/MasterConstant";

class Authentication {
  public static addExpiryTimeToLocalStorage = () => {
    try {
      const additionalMinutes = process.env.REACT_APP_TOKEN_EXPIRY_ADDITIONAL_MINUTES ? +process.env.REACT_APP_TOKEN_EXPIRY_ADDITIONAL_MINUTES : 55;

      const expiryTime = moment().add(additionalMinutes, "minutes").format();
      LocalStorageUtil.localStorageSetItem(LocalStorageConstants.TOKEN_EXPIRY_TIMESTAMP, expiryTime);
    } catch (error) {
      throw error;
    }
  };

  public static isUserSessionActive = () => {
    try {
      const localStorageKeys: string[] = [LocalStorageConstants.TOKEN_EXPIRY_TIMESTAMP, LocalStorageConstants.USER_DATA];

      const isUserActive = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.IS_USER_ACTIVE);
      const isTokenExpired = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.IS_TOKEN_EXPIRED);

      if (isUserActive === LocalStorageValueConstants.FALSE || isTokenExpired === LocalStorageValueConstants.TRUE || !isUserActive || !isTokenExpired) return false;

      /* check if basic keys to access application are present */
      for (const key of localStorageKeys) {
        const value = LocalStorageUtil.localStorageGetItem(key);
        // If key is not found, return false immediately
        if (value === null) return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  };

  // Function to check if a user has access to a specific module
  public static hasModuleAccess = (userData: UserInterface | undefined, moduleToCheck: Modules): boolean => {
    return !!userData?.modules?.some((mod: ModuleOperation) => mod.module === moduleToCheck);
  };

  // Function to check if a user has access to a specific module and operation
  public static hasModuleAndOperationAccess = (userData: UserInterface | undefined, moduleToCheck: Modules, operationToCheck: string): boolean => {
    return !!userData?.modules?.some((mod: ModuleOperation) => {
      // Check if module matches moduleToCheck
      if (mod.module === moduleToCheck) {
        // Check if operations include operationToCheck
        return mod.operations.includes(operationToCheck);
      }
      return false;
    });
  };

  public static getModuleNameById = (selectedId: number | null) => {
    for (const moduleName in ModuleAndIdMapping) {
      if (ModuleAndIdMapping[moduleName as Modules] === selectedId) {
        return moduleName as Modules;
      }
    }
    return "";
  };

  public static checkModuleAccessById = (userData: UserInterface | undefined, selectedId: number | null, operation: string) => {
    if (!selectedId) return false;
    const moduleName = Authentication.getModuleNameById(selectedId);
    if (moduleName) {
      return Authentication.hasModuleAndOperationAccess(userData, moduleName, operation);
    } else {
      return false;
    }
  };
}

export default Authentication;
